import styled from 'styled-components';

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
